import { AppDataGuard } from './app-data.guard';
import { RedirectGuard } from './redirect.guard';

export const guards: any[] = [AppDataGuard, RedirectGuard];

export * from './app-data.guard';
export * from './redirect.guard';
